const RF_PRODUCT_GROUPS = [
  {
    handles: [
      'kniga-retseptov-s-boul-130-retseptov-ot-dietologa',
      'kniga-retseptov-s-boul-200-retseptov-ot-dietologa',
      'upsell-книга-боулов-130-рецептов-от-диетолога',
    ],
    variantIds: [56572308390232, 57594695778648],
  },
  {
    handles: [
      '150-luchshykh-retseptov-ot-dyetoloha',
      '150-luchshykh-retseptov-ot-dyetoloha-ru',
      'upsell-150-уникальних-рецептов-от-диетолога-copy',
    ],
    variantIds: [56571253784920, 57594705969496],
  },
  {
    handles: [
      'vipechka-i-deserti-kotorie-mozhno-est-kazhdii-den',
      'vipechka-i-deserti-kotorie-mozhno-est-kazhdii-den-ru',
      'upsell-выпечка-и-десерты-которые-можно-есть-каждый-день',
    ],
    variantIds: [56571560526168, 57594701185368],
  },
  {
    handles: [
      '480-рецептов-завтраков-обедов-и-ужинов-от-диетолога',
      '650-breakfast-lunch-and-dinner-recipes-from-a-dietitian-ru',
    ],
    variantIds: [57825019658584],
  },
];

const root = document.body;
const currentHandle = root.dataset.productHandle;
const currentVariantId = root.dataset.productVariantId;
const currentGroup = RF_PRODUCT_GROUPS.find((group) => group.handles.includes(currentHandle));

if (currentGroup && currentVariantId) {
  let adding = false;

  const isPurchaseLink = (link) => {
    const href = link.getAttribute('href') || '';
    return href.includes('/cart/add') || /\/cart\/\d+:\d+/.test(href);
  };

  const setBusy = (busy) => {
    document.querySelectorAll('main button[type="submit"], main a[href*="/cart/"]').forEach((control) => {
      if (!(control instanceof HTMLButtonElement || control instanceof HTMLAnchorElement)) return;
      control.setAttribute('aria-busy', String(busy));
      if (control instanceof HTMLButtonElement) control.disabled = busy;
    });
  };

  const goToCart = () => {
    window.location.assign(root.dataset.cartUrl || '/cart');
  };

  const addCurrentProduct = async () => {
    if (adding) return;
    adding = true;
    setBusy(true);

    try {
      const cartResponse = await fetch(`${root.dataset.cartUrl || '/cart'}.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!cartResponse.ok) throw new Error('Unable to read the cart');

      const cart = await cartResponse.json();
      const equivalentAlreadyInCart = cart.items.some((item) => {
        const variantId = Number(item.variant_id || item.id);
        return currentGroup.variantIds.includes(variantId) || currentGroup.handles.includes(item.handle);
      });

      if (!equivalentAlreadyInCart) {
        const addResponse = await fetch(root.dataset.cartAddUrl || '/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{ id: Number(currentVariantId), quantity: 1 }],
          }),
        });
        if (!addResponse.ok) throw new Error('Unable to add the product');
      }

      goToCart();
    } catch (error) {
      console.error('RationFit cart action failed:', error);
      goToCart();
    } finally {
      adding = false;
      setBusy(false);
    }
  };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.closest('main')) return;
      if (!form.action.includes('/cart/add')) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      addCurrentProduct();
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target instanceof Element ? event.target.closest('button[type="submit"]') : null;
      const form = button instanceof HTMLButtonElement ? button.form : null;

      if (
        button instanceof HTMLButtonElement &&
        form instanceof HTMLFormElement &&
        button.closest('main') &&
        form.action.includes('/cart/add')
      ) {
        event.preventDefault();
        event.stopImmediatePropagation();
        addCurrentProduct();
        return;
      }

      const link = event.target instanceof Element ? event.target.closest('a') : null;
      if (!(link instanceof HTMLAnchorElement) || !link.closest('main') || !isPurchaseLink(link)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      addCurrentProduct();
    },
    true
  );
}
